import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import ASRProjectSettings from './ASRProjectSettings';
import TrainingData from './TrainingData';

import $ from 'jquery';
import ASRDeployTab from './AsrDeployTab';
import AsrReportTabSetting from './reports/AsrReportTabSetting';

class ASRLeftPanel extends Component {

  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var projectSettingsPathExist = false;
      var projectSettingsTabsPatterns = ['/api-keys', '/team'];
      for (var i = 0; i < projectSettingsTabsPatterns.length; i++) {
        if (currentPath.includes(projectSettingsTabsPatterns[i]) == true) {
          projectSettingsPathExist = true;
          break;
        }
      }
      var path = window.origin + "/platform/cloud-asr/";
      var path1 = window.origin + "/platform/cloud-asr";
      if (currentPath == path || currentPath == path1 || projectSettingsPathExist) {
        $("#left-panel-menu-projectSettings").addClass('activemenu');
      } else if (currentPath.includes('/demo')) {
        $("#left-panel-menu-demo").addClass('activemenu');
      } else if (currentPath.includes('/nlutab')) {
        $("#left-panel-menu-usage").addClass('activemenu');
      } else if (currentPath.includes('/test-and-deploy')) {
        $("#left-panel-menu-deploy").addClass('activemenu');
      } else if (currentPath.includes('/training-data')) {
        $("#left-panel-menu-training-data").addClass('activemenu');
      } else if (currentPath.includes('/reports')) {
        $("#left-panel-menu-reports").addClass('activemenu');
      }
      else {
        $("#" + localStorage.getItem("last-used-left-panel-tab")).addClass('activemenu')
      }
      $("#left-panel-menu-projectSettings,#left-panel-menu-deploy,#left-panel-menu-training-data, #left-panel-menu-reports")
        .on("click", function () {
          $("#left-panel-menu-projectSettings,#left-panel-menu-deploy,#left-panel-menu-training-data, #left-panel-menu-reports")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')

        })

    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div>
          <link rel="stylesheet" href="./plugins/font-awesome/css/font-awesome.min.css" />
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="./assets/css/adminlte.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />
          <link rel="stylesheet" href="./assets/css/custom-style.css" />
          <link rel="stylesheet" href="./plugins/iCheck/all.css" />
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link href="assets/css/scrollbar.css" rel="stylesheet" />
          <div className="content-wrapper">
            <div className="left-menu" style={{ marginTop: '0px', position: "absolute" }} >
              <ul id="floatMenu">
                <Link to="/cloud-asr">
                  <li id="left-panel-menu-projectSettings" className="tabs">
                    <i className="fa flaticon-ui" /><span>ASR API Settings</span>
                  </li>
                </Link>
                <Link to="/cloud-asr/training-data">
                  <li id="left-panel-menu-training-data" className="tabs">
                    <i className="fa flaticon-ui" /><span>Training Data</span>
                  </li>
                </Link>
                <Link to="/cloud-asr/test-and-deploy">
                  <li id="left-panel-menu-deploy" className="tabs">
                    <i className="fa flaticon-ui" /><span>Test &amp; Deploy</span>
                  </li>
                </Link>
                <Link to="/cloud-asr/reports">
                  <li id="left-panel-menu-reports" className="tabs">
                    <i className="fa flaticon-ui" /><span>Reports</span>
                  </li>
                </Link>
              </ul>
            </div>
          </div>
          <Switch>
            <Route path="/cloud-asr/reports" component={AsrReportTabSetting}></Route>
            <Route path="/cloud-asr/training-data" component={TrainingData}></Route>
            <Route path="/cloud-asr/test-and-deploy" component={ASRDeployTab}></Route>
            <Route path="/cloud-asr" component={ASRProjectSettings}></Route>
          </Switch>
        </div>
      </Router>
    );
  }
}
export default ASRLeftPanel;


// WEBPACK FOOTER //
// ./src/asrUi/ASRLeftPanel.js